
import React, { Component } from 'react';
import { Modal, Form, Input, Row } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import validator from '../../../util/validator';

class ApplyTransferredForm extends Component {

    //回退申请但状态
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["applicationId"] = this.props.applicationId;
            http.post({
                url: '/tradeApplyAgent/saveNewPlateNo',
                data: values,
                success: (res) => {
                    messager.notify("完成过户成功！");
                    this.props.onCancel();
                    this.props.successCallback(this.props.queryData);
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form, plateNo } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="完成车辆过户"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="新车牌号：">
                            {getFieldDecorator('plateNo', {
                                "initialValue": plateNo,
                                "rules": [
                                    { required: true, message: '新车牌号不能为空!' },
                                    validator.plateNo
                                ]
                            })(<Input />)}
                        </Form.Item>
                    </Form>
                </Row>
            </Modal>
        )
    }
}


const ApplyTransferred = Form.create()(ApplyTransferredForm);

export default ApplyTransferred;